module.exports = __webpack_public_path__ + "img/cow-run-1.41b3cb8e.png";